import { FormControl, InputLabel, NativeSelect } from "@mui/material";
import React from "react";
import BootstrapInput from "../BootstrapInput";

interface Props {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const CategoryTypeSelect: React.FC<Props> = ({ value, onChange }) => {
  return (
    <FormControl sx={{ m: 1, width: "100%" }} variant="standard">
      <InputLabel htmlFor="type-select">Type</InputLabel>
      <NativeSelect value={value} onChange={onChange} input={<BootstrapInput />} id="type-select">
        <option value="">Select category</option>
        <option value="Services">Services</option>
        <option value="Products">Products</option>
      </NativeSelect>
    </FormControl>
  );
};

export default CategoryTypeSelect;
